import Backend from "./Backend";
import MOCK_ENCOUNTER from "../resources/MOCK_ENCOUNTER.json";
import MOCK_NOTIFS from "../resources/MOCK_NOTIFS.json";
import MOCK_DATA from "../resources/MOCK_DATA.json";

import axios from "axios";

const PORT =
  "http://SkeleChaingang-env.eba-i65amzvv.us-west-2.elasticbeanstalk.com";
// const PORT = 'http://femr-central-api.us-west-2.elasticbeanstalk.com';
// uncomment it if you are using local backend
//const PORT = 'http://127.0.0.1:8000';

/*
The Development Backend is used for end-to-end testing, and
higher fidelity demos for the client. It is coupled more
tightly to changes made on the backend and is a middling
step between the Demonstration and Production backend
*/

class DevBackend implements Backend {
  amIAlive() {
    return true;
  } //TODO: verify connection to backend

  async userInfo(): Promise<Object> {
    const response = await axios
      .get(`${PORT}/user/`)
      .then((res) => res.data)
      .then((user) => {
        //console.log("test = ", user);
        return user[0];
      });
    //console.log("one user = ", response);
    return response;
  } //TODO: implement once supported

  notifs(): Object {
    return MOCK_NOTIFS;
  } //TODO: implement once supported

  get_campaigns(): Object {
    return MOCK_DATA;
  } //TODO: implement once supported

  async get_encounter(ID: String): Promise<Object> {
    //TODO: ACTUALLY implement by ID once that exists
    return MOCK_ENCOUNTER;
    //return instance.get('/patient-encounter/')[0];
  }
}

export default DevBackend;
